const ontick_schema = process.env.VUE_APP_ONTICK_SCHEMA;
const ontick_host = process.env.VUE_APP_ONTICK_HOST;
const ontick_port = process.env.VUE_APP_ONTICK_PORT;
const ontick_version = process.env.VUE_APP_ONTICK_VERSION;
const ontick_route = `${ontick_schema}://${ontick_host}:${ontick_port}/${ontick_version}`;
const ontick_open_route = `${ontick_schema}://${ontick_host}:${ontick_port}/v1-public`;
const ontick_payment_version = process.env.VUE_APP_PAYMENT_VERSION;
const ontick_payment_port = process.env.VUE_APP_PAYMENT_PORT;
const ontick_payment_route = `${ontick_schema}://${ontick_host}:${ontick_payment_port}/${ontick_payment_version}`;
const ontick_md_port = process.env.VUE_APP_ONTICK_MD_PORT;
// const ontick_md_route = `${ontick_schema}://${ontick_host}:${ontick_md_port}/${ontick_version}`;

// `http://192.168.0.188:5200/v0/charts/orders/` + vm.selectedInvestment
// https://api.ontick.com.br:443/v0/candles/m1/winfut/first-bar-time

//
export default {
  //  Endereço base
  BASE: ontick_route,
  //  MD_BASE: ontick_md_route,
  LOOKUP: `${ontick_route}/symbols/lookup`,
  GET_QUOTES: `${ontick_route}/symbols/quotes`, // post

  //  Get chart's marks.
  GET_MARKERS: `${ontick_route}/charts/markers`,

  GET_TICKER: `${ontick_route}/snapshot/ticker`,
  GET_TICKER_DETAILS: `${ontick_route}/snapshot`,

  //  Login
  LOGIN_USER_LOGIN: `${ontick_route}/login`,
  CPF_VERIFY: `${ontick_route}/users/enable`,
  ADD_ACCOUNT: `${ontick_route}/accounts/activate`,
  LOGIN_HISTORY: `${ontick_route}/users/login-history`,
  RESET_PASSWORD: `${ontick_route}/users/password-reset`,
  PASSSWORD_CONFIRM: `${ontick_route}/users/password-confirm`,
  SIGNATURE_PASSWORD: `${ontick_route}/users/signature-reset`,
  UPDATE_PREFERENCE: `${ontick_route}/preferences/update`,
  GET_PREFERENCES: `${ontick_route}/preferences/all`, // params: { account_id }
  GET_DAILY_SUMMARY_STATUS: `${ontick_route}/preferences/daily_summary?`, // params: { account_id }

  GET_DASHBOARD: `${ontick_route}/users/dashboard`,
  GET_CANDLES: `${ontick_route}/candles`,
  GET_ACCOUNT_PERIOD: `${ontick_route}/users/account-v2/`,

  // =========================================================================
  //  INVESTMENTS

  INVESTMENTS: `${ontick_route}/investments/list`,
  INVESTMENTS_CHECK: `${ontick_route}/investments/check`,
  GET_INVESTMENTS: `${ontick_route}/investments/list-v4`,
  //  INVESTMENTS_PARAMS: `${ontick_route}/investments/params`,
  START_INVESTMENT_PORTFOLIO: `${ontick_route}/portfolios/start`,
  START_INVESTMENT: `${ontick_route}/investments/start`,
  STOP_INVESTMENT: `${ontick_route}/investments/stop`,
  STOP_INVESTMENT_PORTFOLIO: `${ontick_route}/portfolios/stop`,
  STATUS_INVESTMENT_PORTFOLIO: `${ontick_route}/portfolios/status`,
  GET_INVESTMENT_PORTFOLIO: `${ontick_route}/portfolios/components`,
  STOP_ALL_INVESTMENTS: `${ontick_route}/investments/stop-all`,
  INVESTMENT_HIDE: `${ontick_route}/investments/hide`,
  INVESTMENT_SHOW: `${ontick_route}/investments/show`,
  REAL_TIME: `${ontick_route}/investments/real-time`,
  INVESTMENTS_HISTORY: `${ontick_route}/investments/history`,

  // Agendar alteração no volume de operações
  INVESTMENTS_VOLUME_SCHEDULE: `${ontick_route}/investments/schedule`,

  // Cancelar agendamento de alteração no volume de operações
  INVESTMENTS_VOLUME_SCHEDULE_CANCEL: `${ontick_route}/investments/schedule-cancel`,

  // Checar o capacity do investimento
  INVESTMENTS_CHECK_CAPACITY: `${ontick_route}/investments/check-capacity`,

  // =========================================================================

  DISMISS_MASK: `${ontick_route}/notifications/masks/dismiss`,
  CHECK_VOLUME: `${ontick_route}/symbols/volume-check`, //post
  CHECK_GAIN_LOSS: `${ontick_route}/investments/check-gain-loss`, //post

  //  PARAMETERS
  LIST_PARAMS: `${ontick_route}/params/list-v2`,
  CREATE_PARAM: `${ontick_route}/params/create`,
  GET_PARAM_INFO: `${ontick_route}/params`,
  PARAM_RESET: `${ontick_route}/params/reset`,
  PARAM_DELETE: `${ontick_route}/params/delete`,
  UPDATE_PARAMS: `${ontick_route}/params/update`,

  //  Tipo de conta, preferências do usuário, avatar, etc.
  USER_CONFIGS: `${ontick_route}/users/configs`,
  GET_USER_INFO: `${ontick_route}/users/info`,
  POST_USER_INFO: `${ontick_route}/users/update`,
  GET_USER_SIGN: `${ontick_route}/users/subscriptions`,
  POST_USER_SIGN: `${ontick_route}/users/subscriptions/update`,

  GET_USER_TRANSITION: `${ontick_route}/users/transactions`,

  //  PERFORMANCE
  PERFORMANCE_SUMMARY: `${ontick_route}/performance/summary`,
  PERFORMANCE_INVESTMENT: `${ontick_route}/performance/investment`,
  PERFORMANCE_LOGS: `${ontick_route}/logs/list`,
  PERFORMANCE_ORDER_LIST: `${ontick_route}/orders/list`,
  PERFORMANCE_ORDER_INFO: `${ontick_route}/orders/info`,
  PERFORMANCE_CHART: `${ontick_route}/charts/investment`,

  //  MARKETPLACE
  GET_MARKETPLACE: `${ontick_route}/products/list-v4`,
  GET_MARKETPLACE_CATEGORIES: `${ontick_route}/products/categories`,
  GET_MARKETPLACE_CATEGORY: `${ontick_route}/products/category`,
  GET_MARKETPLACE_SEARCH: `${ontick_route}/products/search`,
  GET_MARKETPLACE_FILTERS: `${ontick_route}/products/filters`,
  GET_STRATEGIES_STATISTICS: `${ontick_route}/strategies/statistics`,
  GET_PREFERENCES_MARKETPLACE: `${ontick_route}/preferences/marketplace`,
  UPDATE_PREFERENCES_MARKETPLACE: `${ontick_route}/preferences/update`,
  GET_PRODUCT_PLAN: `${ontick_route}/products/plans`,
  GET_PRODUCT_DETAILS: `${ontick_route}/strategies/info`,
  GET_PRODUCT_FAVORITE: `${ontick_route}/products/favorites`,

  GET_STRATEGIES_OPERATIONS: `${ontick_route}/strategies/operations`,

  // ***********************************************************************
  // * v2 do novo aero                                                     *
  // ***********************************************************************
  GET_STRATEGIES_STATS_V2: `${ontick_route}/strategies/stats`,
  GET_STRATEGIES_OPERATIONS_V2: `${ontick_route}/strategies/operations-v2`,
  GET_STRATEGIES_ORDER_V2: `${ontick_route}/strategies/orders-v2`,
  // ***********************************************************************

  // Rota de info estática do aero de estratégia.
  GET_STRATEGIES_INFO_V2: `${ontick_route}/strategies/info-v2`,
  // Traz os dados dinâmicos do aero de estratégia.
  GET_STRATEGIES_PERFORMANCE_V2: `${ontick_route}/strategies/performance-v2`,

  //  ->  PARTNER MARKETPLACE
  GET_PARTNER_MARKETPLACE: `${ontick_route}/products/partners`, //  ->  /:partner_name/:account_id/:extension_id
  ADD_MARKETPLACE_STRATEGY: `${ontick_route}/products/add`, //  ->  /:product_id/:strategy_id
  ADD_EXTENSION_STRATEGY: `${ontick_route}/products/add-ext`, //  ->  /:product_id/:strategy_id

  //  ->  CATEGORY MARKETPLACE (XP)
  GET_CATEGORY_MARKETPLACE: (category_group, account_id) => {
    return `${ontick_route}/products/categories/${category_group}/${account_id}`;
  },

  GET_PLANS: `${ontick_route}/plans/list`,
  GET_PRO_DATA: `${ontick_route}/plans/pro-rata`,
  SUBSCRIBE_PLAN: `${ontick_route}/plans/subscribe`,
  CANCEL_PLAN: `${ontick_route}/plans/cancel`,
  GET_PLAN_INFO: `${ontick_route}/plans/info`, // -> /:plan_id

  //  PAYMENT
  COUNTRIES_LIST: `${ontick_route}/payments/countries`,
  FREE_PAYMENTS: `${ontick_route}/payments/free`,
  CHECK_INVOICE: `${ontick_route}/invoices/check`,
  GET_INVOICE_INFO: `${ontick_route}/invoices/info`, //  ->  query: 'invoice_type', 'plan_id/extension_id/product_id'
  CREATE_INVOICE: `${ontick_route}/invoices/create`,
  CONFIRM_INVOICE: `${ontick_route}/invoices/confirm`,

  //  SUBSCRIPTIONS
  GET_USER_SUBSCRIPTIONS: `${ontick_route}/users/subscriptions-v2`,
  DISABLE_SUBSCRIPTION: `${ontick_route}/users/subscriptions/disable`,
  ENABLE_SUBSCRIPTION: `${ontick_route}/users/subscriptions/enable`, // (reativar recorrência de assinatura ainda válida)
  RENEW_SUBSCRIPTION: `${ontick_route}/users/subscriptions/renew`,
  CANCEL_ACTIVE_SUBSCRIPTION: `${ontick_route}/users/subscriptions/cancel`,

  //  NOTIFICATIONS
  GET_NOTIFICATIONS: `${ontick_route}/notifications/list`,
  GET_NOTIFICATIONS_TRANSIENT: `${ontick_route}/notifications/transient/list`,
  POST_NOTIFICATIONS_READ: `${ontick_route}/notifications/read`,
  POST_NOTIFICATIONS_READ_ALL: `${ontick_route}/notifications/read-all`,
  POST_NOTIFICATIONS_TRANSIENT_ALL: `${ontick_route}/notifications/transient/dismiss-all`,

  //  EXTENSIONS
  LIST_EXTENSIONS: `${ontick_route}/extensions/list`,
  GET_EXTENSION_DETAILS: `${ontick_route}/extensions/details`, // /:extension_group
  ACTIVATE_EXTENSION: `${ontick_route}/extensions/activate`,
  DISABLE_EXTENSION: `${ontick_route}/extensions/disable`,
  GET_EXTENSION_PARAMS: `${ontick_route}/extensions/params`,
  REACTIVATE_EXTENSION: `${ontick_route}/extensions/re-activate`,
  GET_PAYMENT_INFO: `${ontick_route}/payments/info`,
  CARD_SAVE: `${ontick_route}/payments/card-save`,
  CARD_DELETE: `${ontick_route}/payments/card-delete`,
  ADDRESS_SAVE: `${ontick_route}/payments/address-save`,
  ADDRESS_DELETE: `${ontick_route}/payments/address-delete`,
  COUPONS_CHECK: `${ontick_route}/coupons/check`, // post

  //  BINDINGS
  GET_USER_BINDINGS: `${ontick_route}/bindings/list`,
  GET_SEARCH_PARTNERS: `${ontick_route}/bindings/search?name=`,
  REQUEST_BINDING: `${ontick_route}/bindings/request`,
  CANCEL_BINDING_REQUEST: `${ontick_route}/bindings/cancel`,

  // CHAMPIONSHIP
  CREATE_CHAMPIONSHIP_ACCOUNT: `${ontick_route}/contests/join`,

  // EQUITY CONTROL
  GET_EQUITY_CONTROL: `${ontick_route}/equity-control`, // /:account_id
  ENABLE_EQUITY_CONTROL: `${ontick_route}/equity-control/enable`, // POST body: {account_id}
  DISABLE_EQUITY_CONTROL: `${ontick_route}/equity-control/disable`, // POST body: {account_id}
  UPDATE_EQUITY_CONTROL: `${ontick_route}/equity-control/update`, // POST body: {json}
  RESET_EQUITY_CONTROL: `${ontick_route}/equity-control/reset`, // POST body: {account_id}
  GET_EQUITY_CONTROL_LOGS: `${ontick_route}/equity-control/history`, // /:account_id query

  // LONG & SHORT
  LIST_ALGO_ORDERS: (account_id) => `${ontick_route}/algo-orders/list/${account_id}`, // /:account-id
  CREATE_ALGO_ORDER: `${ontick_route}/algo-orders/create`, // POST
  UPDATE_ALGO_ORDER: `${ontick_route}/algo-orders/update`, // POST
  LIST_ALGO_ORDER_SYMBOLS: `${ontick_route}/algo-orders/list-symbols`, // POST
  CHECK_ALGO_ORDER_SYMBOLS: `${ontick_route}/algo-orders/check-symbols`, // POST
  GET_ALGO_ORDER_DETAILS: `${ontick_route}/algo-orders/info`, // QUERY: ACCOUNT_ID, ALG_ORD_ID
  DELETE_ALGO_ORDER: `${ontick_route}/algo-orders/delete`, // POST - BODY: ACCOUNT_ID, ALG_ORD_ID
  START_ALGO_ORDER: `${ontick_route}/algo-orders/start`, // POST - BODY: ACCOUNT_ID, ALG_ORD_ID
  STOP_ALGO_ORDER: `${ontick_route}/algo-orders/stop`, // POST - BODY: ACCOUNT_ID, ALG_ORD_ID
  DUPLICATE_ALGO_ORDER: `${ontick_route}/algo-orders/duplicate`, // POST - BODY: ACCOUNT_ID, ALG_ORD_ID
  SEARCH_AUTH_STRATEGIES: `${ontick_route}/algo-orders/authorizations/strategies`, // chars
  GET_AUTH_LIST: `${ontick_route}/algo-orders/authorizations`, // account_id
  GET_AUTH_INFO: `${ontick_route}/algo-orders/authorizations/info`, // account_id, aut_id
  AUTH_CREATE: `${ontick_route}/algo-orders/authorizations/create`, // POST - account_id, partner_name, max_positions, global_fin_volume, trade_fin_volume, aut_num_days
  AUTH_DISABLE: `${ontick_route}/algo-orders/authorizations/disable`, // POST - account_id, aut_id
  STOP_TRAIL_ORDER: `${ontick_route}/algo-orders/trail-order/stop`, // POST - BODY: ACCOUNT_ID, ALG_ORD_ID

  // RANKING
  GET_RANKING: `${ontick_route}/ranking/list`,
  GET_RANKING_PRODUCT_PLANS: (product_id, strategy_id) => `${ontick_route}/ranking/plans/${product_id}/${strategy_id}`, // product_id, strategy_id

  // CHECKOUT
  CHECK_USER: `${ontick_open_route}/check-user`, // post
  GET_CHECKOUT_DATA: `${ontick_open_route}/checkout`, // /:ABCDEF
  CREATE_INVOICE_PUBLIC: `${ontick_open_route}/invoices/create`,
  CONFIRM_PAYMENT: `${ontick_open_route}/invoices/confirm`,
  CHECK_COUPON: `${ontick_open_route}/check-coupon`,

  // get symbols
  LIST_SYMBOLS: `${ontick_schema}://${ontick_host}:${ontick_port}/v-0/algo-orders/list-symbols`,

  // =========================================================================

  // TRADE IDEAS
  LIST_TRADE_IDEAS: `${ontick_route}/trade-ideas/list`, // params: { account_id }
  LIST_TRADE_IDEAS_AUTHORIZATIONS: `${ontick_route}/trade-ideas/authorizations`, // params: { account_id, aut_id }
  DISABLE_TRADE_IDEA_AUTHORIZATION: `${ontick_route}/trade-ideas/authorizations/disable`, // params: { account_id }
  SEARCH_AUTH_STRATEGIES: `${ontick_route}/trade-ideas/authorizations/strategies`, // params: { chars }
  GET_TRADE_IDEA_AUTH_INFO: `${ontick_route}/trade-ideas/authorizations/info`, // params: { account_id, aut_id }
  CREATE_TRADE_IDEA_AUTHORIZATION: `${ontick_route}/trade-ideas/authorizations/create`, // params: { account_id, auth_strat_id, user_max_positions, user_trade_volume, user_code}
  START_TRADE_IDEA: `${ontick_route}/trade-ideas/start`, // { account_id, ti_id, trade_volume, user_code}
  GET_TRADE_IDEA_INFO: `${ontick_route}/trade-ideas/info`, // /:ti_id

  // Lista de histórico de trade ideas finalizadas
  LIST_TRADE_IDEAS_HISTORY: `${ontick_route}/trade-ideas/list-history`, // params: { account_id }

  // Nova versão da listagem de trade ideas (v2)
  LIST_TRADE_IDEAS_V2: `${ontick_route}/trade-ideas/list-v2`, // params: { account_id }

  // POST: /trade-ideas/auth-strategy/stop
  STOP_STRATEGY: `${ontick_route}/trade-ideas/auth-strategy/stop`, // params: { account_id, auth_strat_id }

  // POST: /trade-ideas/stop
  STOP_TRADE_IDEA: `${ontick_route}/trade-ideas/stop`, // params: { account_id, ti_id, auth_strat_id }

  // =========================================================================

  // TradingView Chart
  GET_BARS_SYMBOL: `${ontick_route}/bars`,
  // http://10.80.10.89:5200/v0/bars/WINFUT/M1

  // Get markers
  GET_MARKERS: `${ontick_route}/charts/trades`,

  // BEST
  LIST_BESTS: `${ontick_route}/bests/list`, // params: { account_id }
  CREATE_BEST: `${ontick_route}/bests/create`, // params: { account_id, best_id, best_multiplier, best_target }
  STOP_BEST: `${ontick_route}/bests/stop`, // params: { account_id, bo_id }
  GET_BESTS_HISTORY: `${ontick_route}/bests/history`, // params: { account_id, page }
  GET_BESTS_RANKING: `${ontick_route}/bests/ranking`, // params: { account_id }
};
